export default {
  readers: [
    'DecarbonizationReaders',
    'Admin'
  ],
  collaborators: [
    'DecarbonizationCollaborators',
    'Admin'
  ],
  admins:[
    'DecarbonizationCollaborators',
    'Admin'
  ]
}
